import { useState } from "react";
import Navbar from "./components/Navbar";
import Ticker from "./components/Ticker";
import Hero from "./components/Hero";
import HotRank from "./components/HotRank";
import EventFeed from "./components/EventFeed";
import TimelineSection from "./components/TimelineSection";
import Faq from "./components/Faq";
import About from "./components/About";
import Footer from "./components/Footer";
import FloatingBar from "./components/FloatingBar";

export default function Home() {
  const [active, setActive] = useState("all");
  const [query, setQuery] = useState("");

  return (
    <div id="top" className="relative w-full overflow-x-hidden bg-background-50">
      <Navbar />
      <main>
        <Hero
          onSearch={(q) => {
            setQuery(q);
            document.getElementById("feed")?.scrollIntoView({ behavior: "smooth" });
          }}
          onCategory={(id) => {
            setActive(id);
            setQuery("");
          }}
        />
        <Ticker />
        <HotRank />
        <EventFeed
          active={active}
          query={query}
          onCategory={setActive}
          onClearQuery={() => setQuery("")}
        />
        <TimelineSection />
        <Faq />
        <About />
      </main>
      <Footer />
      <FloatingBar />
    </div>
  );
}